function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,158.69a62.12,62.12,0,0,0-9-21.57l7.73-9.34-16.52-16.52L224.92,119a62.44,62.44,0,0,0-21.58-9l-1.13-12H178.85l-1.14,12a62.31,62.31,0,0,0-21.57,9l-9.34-7.73-16.52,16.52,7.73,9.34a62.31,62.31,0,0,0-9,21.57l-12,1.14v23.36l12,1.13a62.44,62.44,0,0,0,9,21.58l-7.73,9.33,16.52,16.52,9.34-7.73a62.12,62.12,0,0,0,21.57,9l1.14,12h23.36l1.13-12a62.25,62.25,0,0,0,21.58-9l9.33,7.73,16.52-16.52L243,205.9a62.25,62.25,0,0,0,9-21.58l12-1.13V159.83Zm-29.86,12.82a31.63,31.63,0,1,1-31.62-31.63A31.62,31.62,0,0,1,222.15,171.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319,270.81l.82,8.64h16.78l.81-8.64a44.92,44.92,0,0,0,15.51-6.45l6.7,5.55L371.5,258l-5.55-6.7a45,45,0,0,0,6.45-15.5L381,235V218.24l-8.64-.82a45,45,0,0,0-6.45-15.5l5.55-6.7-11.87-11.87-6.7,5.55a44.92,44.92,0,0,0-15.51-6.45l-.81-8.64H319.83l-.82,8.64a44.87,44.87,0,0,0-15.5,6.45l-6.71-5.55-11.87,11.87,5.56,6.7a45,45,0,0,0-6.45,15.5l-8.64.82V235l8.64.82a45,45,0,0,0,6.45,15.5l-5.56,6.7,11.87,11.87,6.71-5.55A44.87,44.87,0,0,0,319,270.81Zm9.21-21.46a22.72,22.72,0,1,1,22.72-22.72A22.72,22.72,0,0,1,328.22,249.35Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.88,388.34h20l1-10.29a53.38,53.38,0,0,0,18.46-7.67l8,6.61,14.13-14.13-6.6-8a53.33,53.33,0,0,0,7.67-18.45l10.29-1v-20l-10.29-1A53.38,53.38,0,0,0,284.8,296l6.6-8-14.13-14.12-8,6.6a53.38,53.38,0,0,0-18.46-7.67l-1-10.29h-20l-1,10.29a53.46,53.46,0,0,0-18.46,7.67l-8-6.6-14.13,14.12,6.61,8a53.38,53.38,0,0,0-7.67,18.46l-10.29,1v20l10.29,1A53.33,53.33,0,0,0,195,354.87l-6.61,8L202.47,377l8-6.61a53.46,53.46,0,0,0,18.46,7.67Zm10-35.83a27.06,27.06,0,1,1,27.06-27.05A27,27,0,0,1,239.87,352.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.86,145.52a8.22,8.22,0,1,1-11.23-3A8.22,8.22,0,0,1,334.86,145.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.67,148.91c.25.44.76.42,1.39.27l-.94-1.63C325.52,148,325.44,148.51,325.67,148.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.56,150l.93,1.62c.61-.48.72-1,.49-1.35S329.2,149.88,328.56,150Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.23,143.56a7,7,0,1,0,9.59,2.57A7,7,0,0,0,324.23,143.56Zm5.84,9.1.59,1-.75.43-.59-1a4.61,4.61,0,0,1-2.68.53l-.12-1.16a4.09,4.09,0,0,0,2.23-.36l-1.05-1.84c-1.16.34-2.44.64-3.18-.63-.54-.93-.33-2.14,1-3.1l-.6-1,.75-.43.59,1a4.53,4.53,0,0,1,2.18-.52l.16,1.14a4.37,4.37,0,0,0-1.77.37l1.07,1.85c1.16-.34,2.45-.66,3.19.61C331.64,150.48,331.42,151.69,330.07,152.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.96,
    cy: 356.54,
    r: 13.39,
    transform: "translate(-250.05 258.56) rotate(-57.64)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.56,353.25c-.25.79.34,1.37,1.2,2l.94-2.92C109.48,352.1,108.8,352.53,108.56,353.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.36,358l-.93,2.9c1.26.2,1.94-.19,2.17-.9S111.25,358.56,110.36,358Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.45,345.66A11.43,11.43,0,1,0,120.84,360,11.42,11.42,0,0,0,113.45,345.66Zm-4.59,17-.59,1.84-1.34-.43.58-1.82a7.47,7.47,0,0,1-3.58-2.65l1.27-1.42a6.52,6.52,0,0,0,2.88,2.3l1-3.28c-1.68-1-3.44-2.24-2.71-4.52.53-1.67,2.21-2.74,4.85-2.17l.59-1.85,1.35.43-.58,1.82a7.39,7.39,0,0,1,3,2.07l-1.2,1.44a7.14,7.14,0,0,0-2.37-1.74L111,356c1.67,1,3.47,2.24,2.74,4.52C113.21,362.17,111.52,363.22,108.86,362.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.77,
    cy: 283.88,
    r: 13.39,
    transform: "translate(-63.2 132.55) rotate(-16.53)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.38,282.76c.43.71,1.25.65,2.26.39l-1.57-2.63C421.12,281.31,421,282.11,421.38,282.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.11,284.53l1.56,2.61c1-.8,1.14-1.58.76-2.21S427.14,284.25,426.11,284.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.92,274.07a11.43,11.43,0,1,0,15.66,4A11.41,11.41,0,0,0,418.92,274.07Zm9.71,14.69,1,1.65-1.22.73-1-1.65a7.54,7.54,0,0,1-4.35.94l-.22-1.89a6.64,6.64,0,0,0,3.62-.64l-1.76-3c-1.88.58-4,1.1-5.18-1-.9-1.51-.59-3.47,1.58-5.07l-1-1.67,1.21-.72,1,1.64a7.32,7.32,0,0,1,3.54-.89l.28,1.85a7.11,7.11,0,0,0-2.87.63l1.78,3c1.88-.58,4-1.13,5.2.93C431.14,285.17,430.81,287.14,428.63,288.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.52,114.56a13.39,13.39,0,1,1-2.65-18.74A13.37,13.37,0,0,1,295.52,114.56Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.58,103c-.5.67-.13,1.41.49,2.25l1.84-2.45C285.82,102.16,285,102.35,284.58,103Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.73,108l-1.83,2.43c1.12.61,1.89.46,2.34-.13S285.38,108.85,284.73,108Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69,97.38a11.43,11.43,0,1,0,2.26,16A11.43,11.43,0,0,0,291.69,97.38Zm-9.92,14.55-1.16,1.54-1.13-.84,1.15-1.53a7.58,7.58,0,0,1-2.51-3.68l1.66-.92a6.66,6.66,0,0,0,2,3.11l2.07-2.75c-1.25-1.52-2.51-3.24-1.08-5.16,1.06-1.4,3-1.86,5.3-.45l1.17-1.56,1.13.85-1.15,1.53a7.43,7.43,0,0,1,2.16,2.94l-1.61,1a7.25,7.25,0,0,0-1.67-2.42L286,106.33c1.25,1.52,2.55,3.26,1.11,5.17C286,112.9,284.1,113.34,281.77,111.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.05,156.86A9,9,0,1,1,80.9,160.6,9,9,0,0,1,93.05,156.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.51,165.33c.49.26.94-.06,1.43-.56l-1.82-1C85.85,164.59,86.06,165.1,86.51,165.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.83,164.7l1.81,1c.28-.81.1-1.31-.34-1.54S90.33,164.18,89.83,164.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.07,161.21A7.67,7.67,0,1,0,92.43,158,7.66,7.66,0,0,0,82.07,161.21Zm10.68,5,1.15.6-.45.84-1.13-.6a5,5,0,0,1-2.17,2l-.79-1a4.48,4.48,0,0,0,1.86-1.63l-2-1.08c-.88,1-1.89,2-3.31,1.25-1-.55-1.55-1.79-.86-3.46l-1.15-.61.44-.84,1.13.6a5.11,5.11,0,0,1,1.72-1.74l.81,1A4.63,4.63,0,0,0,86.54,163l2.06,1.09c.87-1,1.89-2,3.3-1.28C93,163.32,93.44,164.56,92.75,166.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,237.61a8.56,8.56,0,1,1-11.57,3.56A8.57,8.57,0,0,1,254,237.61Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.77,245.68c.47.25.9-.05,1.37-.53l-1.74-.92C247.15,245,247.34,245.46,247.77,245.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.94,245.08l1.72.91c.27-.76.1-1.24-.32-1.46S251.41,244.59,250.94,245.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.54,241.76a7.3,7.3,0,1,0,9.87-3A7.3,7.3,0,0,0,243.54,241.76Zm10.18,4.8,1.09.57-.42.8-1.08-.57a4.86,4.86,0,0,1-2.07,1.95l-.75-.95a4.21,4.21,0,0,0,1.77-1.56l-1.95-1c-.83.94-1.8,1.91-3.15,1.2-1-.53-1.47-1.7-.82-3.3l-1.09-.58.42-.8,1.08.57a4.83,4.83,0,0,1,1.64-1.66l.77.92a4.59,4.59,0,0,0-1.36,1.3l2,1c.84-.94,1.8-1.94,3.15-1.22C253.9,243.76,254.37,245,253.72,246.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.49,348.05a19.5,19.5,0,1,1-12.62-24.53A19.51,19.51,0,0,1,380.49,348.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.89,337.31c-.37,1.14.49,2,1.74,2.85l1.37-4.25C361.22,335.63,360.22,336.26,359.89,337.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.51,344.18l-1.36,4.22c1.83.3,2.83-.28,3.16-1.3C364.68,345.93,363.81,345,362.51,344.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,326.24a16.65,16.65,0,1,0,10.77,20.93A16.66,16.66,0,0,0,367,326.24ZM360.32,351l-.86,2.67-2-.63.85-2.65a11,11,0,0,1-5.22-3.85l1.85-2.07a9.69,9.69,0,0,0,4.2,3.34l1.53-4.77c-2.45-1.5-5-3.27-3.95-6.59.78-2.43,3.23-4,7.07-3.16l.87-2.7,1.95.63-.85,2.65a10.88,10.88,0,0,1,4.39,3l-1.76,2.1a10.47,10.47,0,0,0-3.45-2.53l-1.55,4.83c2.45,1.49,5.07,3.25,4,6.57C366.65,350.3,364.19,351.83,360.32,351Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.58,281.18a19.5,19.5,0,1,1,7.69-26.48A19.51,19.51,0,0,1,89.58,281.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,259.22c-1.06.58-1,1.79-.69,3.27l3.91-2.15C84.12,258.91,83,258.68,82,259.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.17,266l-3.89,2.14c1.13,1.47,2.25,1.74,3.19,1.22S79.53,267.53,79.17,266Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.77,256.07a16.65,16.65,0,1,0-6.57,22.61A16.65,16.65,0,0,0,94.77,256.07ZM72.89,269.46l-2.46,1.35-1-1.8,2.44-1.34a10.94,10.94,0,0,1-1.14-6.39l2.76-.23a9.72,9.72,0,0,0,.75,5.31l4.4-2.41c-.75-2.77-1.4-5.82,1.66-7.5,2.24-1.23,5.09-.68,7.3,2.57l2.49-1.36,1,1.8-2.44,1.34a10.78,10.78,0,0,1,1.11,5.2l-2.72.32a10.41,10.41,0,0,0-.77-4.22l-4.44,2.44c.75,2.77,1.44,5.85-1.61,7.53C78,273.3,75.14,272.72,72.89,269.46Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 175.16,
    y: 126.23,
    width: 161.68,
    height: 290.81,
    rx: 9.69,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.16,
    y: 126.23,
    width: 161.68,
    height: 290.81,
    rx: 9.69,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.16,132.68a1.33,1.33,0,0,1-2.65,0,1.33,1.33,0,1,1,2.65,0Z",
    style: {
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.39,136V406.78a4,4,0,0,1-4,4H184.2a3.55,3.55,0,0,1-3.59-3.64V135.64a3.2,3.2,0,0,1,3.08-3.32h35.79a2.53,2.53,0,0,1,2.31,1.61l1.48,3.65a2.5,2.5,0,0,0,2.3,1.59h60.94a2.49,2.49,0,0,0,2.3-1.56l1.48-3.67a2.54,2.54,0,0,1,2.31-1.62h35.27A3.62,3.62,0,0,1,331.39,136Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.61,
    y: 149.24,
    width: 150.77,
    height: 243.54,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.33,
    y: 180.68,
    width: 143.33,
    height: 208.66,
    style: {
      fill: "#7E57C2",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.33,
    y: 180.68,
    width: 143.33,
    height: 208.66,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.19,404.12h-2.38a2.27,2.27,0,0,1-2.27-2.27v-2.37a2.27,2.27,0,0,1,2.27-2.27h2.38a2.27,2.27,0,0,1,2.27,2.27v2.37A2.27,2.27,0,0,1,257.19,404.12Zm-2.38-6a1.34,1.34,0,0,0-1.33,1.34v2.37a1.34,1.34,0,0,0,1.33,1.34h2.38a1.34,1.34,0,0,0,1.33-1.34v-2.37a1.34,1.34,0,0,0-1.33-1.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.33,
    y: 154.01,
    width: 143.33,
    height: 24.56,
    style: {
      fill: "#7E57C2",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.75,162.1a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,320.75,162.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.75,166.3a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,320.75,166.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.75,170.49a1.1,1.1,0,0,1-2.2,0,1.1,1.1,0,1,1,2.2,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.55,170.12l.71-1.6a6.21,6.21,0,0,0,3.67,1.22c1.73,0,2.47-.62,2.47-1.45,0-2.39-6.61-.82-6.61-4.95,0-1.8,1.43-3.32,4.48-3.32a7.09,7.09,0,0,1,3.7,1l-.65,1.61a6.18,6.18,0,0,0-3.07-.88c-1.71,0-2.41.67-2.41,1.51,0,2.37,6.59.83,6.59,4.91,0,1.78-1.45,3.31-4.5,3.31A7.18,7.18,0,0,1,230.55,170.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.68,168.72h-5.56L242,171.3H239.9l5-11.12h2l5,11.12H249.8ZM248,167.1l-2.1-4.86-2.08,4.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.37,160.18h2.06v9.37h5.81v1.75h-7.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.22,169.56v1.74h-8.34V160.18H271v1.73h-6.05v2.89h5.37v1.7h-5.37v3.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.58,170.12l.71-1.6a6.21,6.21,0,0,0,3.67,1.22c1.73,0,2.46-.62,2.46-1.45,0-2.39-6.6-.82-6.6-4.95,0-1.8,1.42-3.32,4.47-3.32a7.1,7.1,0,0,1,3.71,1l-.66,1.61a6.14,6.14,0,0,0-3.06-.88c-1.72,0-2.42.67-2.42,1.51,0,2.37,6.6.83,6.6,4.91,0,1.78-1.45,3.31-4.5,3.31A7.18,7.18,0,0,1,272.58,170.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.06,283.23H320.94a4.4,4.4,0,0,1,4.4,4.4V389.34a0,0,0,0,1,0,0H186.67a0,0,0,0,1,0,0V287.62A4.4,4.4,0,0,1,191.06,283.23Z",
    style: {
      fill: "#7E57C2",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.06,283.23H320.94a4.4,4.4,0,0,1,4.4,4.4V389.34a0,0,0,0,1,0,0H186.67a0,0,0,0,1,0,0V287.62A4.4,4.4,0,0,1,191.06,283.23Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,384.67a.46.46,0,0,1-.22-.06l-5.89-3.12a.47.47,0,0,1-.2-.63.46.46,0,0,1,.63-.19l5.68,3,5.68-3a.45.45,0,0,1,.63.19.47.47,0,0,1-.2.63l-5.89,3.12A.43.43,0,0,1,256,384.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,380.94a.59.59,0,0,1-.22-.05l-5.89-3.13a.46.46,0,1,1,.43-.82l5.68,3,5.68-3a.46.46,0,1,1,.43.82l-5.89,3.13A.54.54,0,0,1,256,380.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.23,
    y: 140.75,
    width: 1.86,
    height: 2.48,
    transform: "translate(396.32 283.99) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.19,
    y: 139.92,
    width: 1.86,
    height: 3.31,
    transform: "translate(390.25 283.16) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.16,
    y: 139.1,
    width: 1.86,
    height: 4.14,
    transform: "translate(384.18 282.33) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.12,
    y: 138.27,
    width: 1.86,
    height: 4.97,
    transform: "translate(378.11 281.5) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.22,
    y: 139.85,
    width: 1.1,
    height: 2.48,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.08,
    y: 138.94,
    width: 8.79,
    height: 4.29,
    transform: "translate(638.96 282.17) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.13,317.11a2,2,0,1,0,2,2A2,2,0,0,0,205.13,317.11Zm0,3.09a1.06,1.06,0,1,1,1.05-1.06A1.05,1.05,0,0,1,205.13,320.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.54,317.11a2,2,0,1,0,2,2A2,2,0,0,0,221.54,317.11Zm0,3.09a1.06,1.06,0,1,1,1.06-1.06A1.05,1.05,0,0,1,221.54,320.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.42,316.82a.49.49,0,1,0,0-1H204.25a.49.49,0,1,0,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,301.53H203.68a.49.49,0,0,0-.38.18.48.48,0,0,0-.1.41l2.61,12.81a.48.48,0,0,0,.48.39h14.09a.48.48,0,0,0,.48-.39l2.53-12.42H227a.49.49,0,0,0,0-1Zm-5.32,4.27h-4.85l.16-3.29h5.36Zm-.87,4.27h-4.2l.17-3.29h4.7Zm-9.85,0-.17-3.29h5l-.17,3.29Zm4.62,1-.17,3.29h-4.23l-.17-3.29Zm-10.48-4.27h4.71l.17,3.29h-4.2Zm5.64-1-.17-3.29h5.44l-.16,3.29Zm-1.14-3.29.16,3.29H205l-.68-3.29ZM206,311.05h4.06l.17,3.29h-3.55Zm14,3.29h-3.55l.17-3.29h4.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 194.16,
    y: 291.21,
    width: 38.29,
    height: 38.29,
    rx: 1.79,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,312l.33-.76a2.9,2.9,0,0,0,1.73.58c.82,0,1.16-.29,1.16-.68,0-1.13-3.11-.39-3.11-2.34,0-.84.67-1.56,2.11-1.56a3.3,3.3,0,0,1,1.74.47l-.31.75A2.85,2.85,0,0,0,205,308c-.81,0-1.14.31-1.14.71,0,1.11,3.11.39,3.11,2.31,0,.84-.68,1.56-2.12,1.56A3.39,3.39,0,0,1,202.76,312Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.52,309.92a2.82,2.82,0,1,1,2.82,2.7A2.69,2.69,0,0,1,207.52,309.92Zm4.66,0a1.84,1.84,0,1,0-1.84,1.84A1.78,1.78,0,0,0,212.18,309.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.19,307.31h1v4.41h2.73v.82h-3.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.66,307.31H221a2.62,2.62,0,1,1,0,5.23h-2.29Zm2.24,4.41a1.8,1.8,0,1,0,0-3.59h-1.27v3.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.45,317.11a2,2,0,1,0,2,2A2,2,0,0,0,247.45,317.11Zm0,3.09a1.06,1.06,0,1,1,0-2.12,1.06,1.06,0,1,1,0,2.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.87,317.11a2,2,0,1,0,2,2A2,2,0,0,0,263.87,317.11Zm0,3.09a1.06,1.06,0,1,1,1.05-1.06A1.05,1.05,0,0,1,263.87,320.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.74,316.82a.49.49,0,0,0,0-1H246.57a.49.49,0,0,0,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.37,301.53H246a.49.49,0,0,0-.38.18.51.51,0,0,0-.1.41l2.61,12.81a.49.49,0,0,0,.48.39H262.7a.48.48,0,0,0,.48-.39l2.53-12.42h3.66a.49.49,0,0,0,0-1Zm-5.32,4.27h-4.86l.17-3.29h5.36Zm-.87,4.27H259l.17-3.29h4.71Zm-9.86,0-.17-3.29h5l-.17,3.29Zm4.62,1-.17,3.29h-4.23l-.17-3.29Zm-10.47-4.27h4.71l.16,3.29h-4.2Zm5.63-1-.16-3.29h5.44l-.17,3.29ZM252,302.51l.17,3.29h-4.86l-.67-3.29Zm-3.62,8.54h4l.17,3.29H249Zm14,3.29h-3.56l.17-3.29H263Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 236.49,
    y: 291.21,
    width: 38.29,
    height: 38.29,
    rx: 1.79,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.08,312l.34-.76a2.84,2.84,0,0,0,1.72.58c.82,0,1.16-.29,1.16-.68,0-1.13-3.11-.39-3.11-2.34,0-.84.67-1.56,2.11-1.56a3.28,3.28,0,0,1,1.74.47l-.3.75a2.91,2.91,0,0,0-1.45-.41c-.8,0-1.13.31-1.13.71,0,1.11,3.1.39,3.1,2.31,0,.84-.68,1.56-2.12,1.56A3.39,3.39,0,0,1,245.08,312Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.85,309.92a2.82,2.82,0,1,1,2.81,2.7A2.68,2.68,0,0,1,249.85,309.92Zm4.65,0a1.84,1.84,0,1,0-1.84,1.84A1.78,1.78,0,0,0,254.5,309.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.51,307.31h1v4.41h2.74v.82h-3.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,307.31h2.29a2.63,2.63,0,1,1,0,5.23H261Zm2.25,4.41a1.8,1.8,0,1,0,0-3.59H262v3.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.77,317.11a2,2,0,1,0,2,2A2,2,0,0,0,289.77,317.11Zm0,3.09a1.06,1.06,0,1,1,1.06-1.06A1.06,1.06,0,0,1,289.77,320.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.19,317.11a2,2,0,1,0,2,2A2,2,0,0,0,306.19,317.11Zm0,3.09a1.06,1.06,0,1,1,1.06-1.06A1.06,1.06,0,0,1,306.19,320.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.06,316.82a.49.49,0,0,0,0-1H288.9a.49.49,0,1,0,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.69,301.53H288.32a.49.49,0,0,0-.38.18.51.51,0,0,0-.1.41l2.61,12.81a.49.49,0,0,0,.48.39H305a.49.49,0,0,0,.48-.39L308,302.51h3.65a.49.49,0,1,0,0-1Zm-5.32,4.27h-4.86l.17-3.29H307Zm-.87,4.27h-4.21l.17-3.29h4.71Zm-9.85,0-.17-3.29h5l-.17,3.29Zm4.61,1-.17,3.29h-4.23l-.16-3.29Zm-10.47-4.27h4.71l.17,3.29h-4.21Zm5.64-1-.17-3.29h5.44l-.17,3.29Zm-1.15-3.29.17,3.29h-4.86l-.67-3.29Zm-3.62,8.54h4.06l.16,3.29h-3.55Zm14,3.29h-3.56l.17-3.29h4.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 278.81,
    y: 291.21,
    width: 38.29,
    height: 38.29,
    rx: 1.79,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.4,312l.34-.76a2.87,2.87,0,0,0,1.73.58c.81,0,1.15-.29,1.15-.68,0-1.13-3.11-.39-3.11-2.34,0-.84.68-1.56,2.11-1.56a3.28,3.28,0,0,1,1.74.47l-.3.75a2.88,2.88,0,0,0-1.45-.41c-.8,0-1.13.31-1.13.71,0,1.11,3.1.39,3.1,2.31,0,.84-.68,1.56-2.11,1.56A3.42,3.42,0,0,1,287.4,312Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.17,309.92a2.82,2.82,0,1,1,2.82,2.7A2.68,2.68,0,0,1,292.17,309.92Zm4.66,0a1.84,1.84,0,1,0-1.84,1.84A1.79,1.79,0,0,0,296.83,309.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.83,307.31h1v4.41h2.74v.82h-3.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,307.31h2.29a2.63,2.63,0,1,1,0,5.23H303.3Zm2.25,4.41a1.8,1.8,0,1,0,0-3.59h-1.27v3.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.13,359.11a2,2,0,1,0,2,2A2,2,0,0,0,205.13,359.11Zm0,3.09a1.06,1.06,0,1,1,1.05-1.05A1.05,1.05,0,0,1,205.13,362.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.54,359.11a2,2,0,1,0,2,2A2,2,0,0,0,221.54,359.11Zm0,3.09a1.06,1.06,0,1,1,1.06-1.05A1,1,0,0,1,221.54,362.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.42,358.82a.49.49,0,1,0,0-1H204.25a.49.49,0,1,0,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,343.54H203.68a.46.46,0,0,0-.38.18.45.45,0,0,0-.1.4l2.61,12.81a.48.48,0,0,0,.48.39h14.09a.48.48,0,0,0,.48-.39l2.53-12.42H227a.48.48,0,0,0,.49-.48A.49.49,0,0,0,227,343.54Zm-5.32,4.27h-4.85l.16-3.3h5.36Zm-.87,4.27h-4.2l.17-3.3h4.7Zm-9.85,0-.17-3.3h5l-.17,3.3Zm4.62,1-.17,3.29h-4.23l-.17-3.29Zm-10.48-4.27h4.71l.17,3.3h-4.2Zm5.64-1-.17-3.3h5.44l-.16,3.3Zm-1.14-3.3.16,3.3H205l-.68-3.3ZM206,353.05h4.06l.17,3.29h-3.55Zm14,3.29h-3.55l.17-3.29h4.05Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 194.16,
    y: 333.21,
    width: 38.29,
    height: 38.29,
    rx: 1.79,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.76,354l.33-.76a2.9,2.9,0,0,0,1.73.58c.82,0,1.16-.29,1.16-.68,0-1.13-3.11-.39-3.11-2.33,0-.85.67-1.57,2.11-1.57a3.3,3.3,0,0,1,1.74.47l-.31.75A3,3,0,0,0,205,350c-.81,0-1.14.32-1.14.71,0,1.12,3.11.39,3.11,2.31,0,.84-.68,1.56-2.12,1.56A3.39,3.39,0,0,1,202.76,354Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.52,351.93a2.82,2.82,0,1,1,2.82,2.69A2.69,2.69,0,0,1,207.52,351.93Zm4.66,0a1.84,1.84,0,1,0-1.84,1.84A1.78,1.78,0,0,0,212.18,351.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.19,349.31h1v4.41h2.73v.82h-3.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.66,349.31H221a2.62,2.62,0,1,1,0,5.23h-2.29Zm2.24,4.41a1.8,1.8,0,1,0,0-3.59h-1.27v3.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.45,359.11a2,2,0,1,0,2,2A2,2,0,0,0,247.45,359.11Zm0,3.09a1.06,1.06,0,1,1,1.06-1.05A1.05,1.05,0,0,1,247.45,362.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.87,359.11a2,2,0,1,0,2,2A2,2,0,0,0,263.87,359.11Zm0,3.09a1.06,1.06,0,1,1,1.05-1.05A1.05,1.05,0,0,1,263.87,362.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.74,358.82a.49.49,0,0,0,0-1H246.57a.49.49,0,0,0,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.37,343.54H246a.46.46,0,0,0-.38.18.48.48,0,0,0-.1.4l2.61,12.81a.49.49,0,0,0,.48.39H262.7a.48.48,0,0,0,.48-.39l2.53-12.42h3.66a.48.48,0,0,0,.49-.48A.49.49,0,0,0,269.37,343.54Zm-5.32,4.27h-4.86l.17-3.3h5.36Zm-.87,4.27H259l.17-3.3h4.71Zm-9.86,0-.17-3.3h5l-.17,3.3Zm4.62,1-.17,3.29h-4.23l-.17-3.29Zm-10.47-4.27h4.71l.16,3.3h-4.2Zm5.63-1-.16-3.3h5.44l-.17,3.3Zm-1.14-3.3.17,3.3h-4.86l-.67-3.3Zm-3.62,8.54h4l.17,3.29H249Zm14,3.29h-3.56l.17-3.29H263Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 236.49,
    y: 333.21,
    width: 38.29,
    height: 38.29,
    rx: 1.79,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.08,354l.34-.76a2.84,2.84,0,0,0,1.72.58c.82,0,1.16-.29,1.16-.68,0-1.13-3.11-.39-3.11-2.33,0-.85.67-1.57,2.11-1.57a3.28,3.28,0,0,1,1.74.47l-.3.75a3,3,0,0,0-1.45-.41c-.8,0-1.13.32-1.13.71,0,1.12,3.1.39,3.1,2.31,0,.84-.68,1.56-2.12,1.56A3.39,3.39,0,0,1,245.08,354Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.85,351.93a2.82,2.82,0,1,1,2.81,2.69A2.68,2.68,0,0,1,249.85,351.93Zm4.65,0a1.84,1.84,0,1,0-1.84,1.84A1.78,1.78,0,0,0,254.5,351.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.51,349.31h1v4.41h2.74v.82h-3.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,349.31h2.29a2.63,2.63,0,1,1,0,5.23H261Zm2.25,4.41a1.8,1.8,0,1,0,0-3.59H262v3.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.77,359.11a2,2,0,1,0,2,2A2,2,0,0,0,289.77,359.11Zm0,3.09a1.06,1.06,0,1,1,1.06-1.05A1.06,1.06,0,0,1,289.77,362.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.19,359.11a2,2,0,1,0,2,2A2,2,0,0,0,306.19,359.11Zm0,3.09a1.06,1.06,0,1,1,1.06-1.05A1.06,1.06,0,0,1,306.19,362.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.06,358.82a.49.49,0,0,0,0-1H288.9a.49.49,0,1,0,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.69,343.54H288.32a.46.46,0,0,0-.38.18.48.48,0,0,0-.1.4l2.61,12.81a.49.49,0,0,0,.48.39H305a.49.49,0,0,0,.48-.39L308,344.51h3.65a.48.48,0,0,0,.49-.48A.49.49,0,0,0,311.69,343.54Zm-5.32,4.27h-4.86l.17-3.3H307Zm-.87,4.27h-4.21l.17-3.3h4.71Zm-9.85,0-.17-3.3h5l-.17,3.3Zm4.61,1-.17,3.29h-4.23l-.16-3.29Zm-10.47-4.27h4.71l.17,3.3h-4.21Zm5.64-1-.17-3.3h5.44l-.17,3.3Zm-1.15-3.3.17,3.3h-4.86l-.67-3.3Zm-3.62,8.54h4.06l.16,3.29h-3.55Zm14,3.29h-3.56l.17-3.29h4.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 278.81,
    y: 333.21,
    width: 38.29,
    height: 38.29,
    rx: 1.79,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.4,354l.34-.76a2.87,2.87,0,0,0,1.73.58c.81,0,1.15-.29,1.15-.68,0-1.13-3.11-.39-3.11-2.33,0-.85.68-1.57,2.11-1.57a3.28,3.28,0,0,1,1.74.47l-.3.75a3,3,0,0,0-1.45-.41c-.8,0-1.13.32-1.13.71,0,1.12,3.1.39,3.1,2.31,0,.84-.68,1.56-2.11,1.56A3.42,3.42,0,0,1,287.4,354Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.17,351.93a2.82,2.82,0,1,1,2.82,2.69A2.68,2.68,0,0,1,292.17,351.93Zm4.66,0a1.84,1.84,0,1,0-1.84,1.84A1.79,1.79,0,0,0,296.83,351.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.83,349.31h1v4.41h2.74v.82h-3.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,349.31h2.29a2.63,2.63,0,1,1,0,5.23H303.3Zm2.25,4.41a1.8,1.8,0,1,0,0-3.59h-1.27v3.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 232.56,
    r: 42.02,
    transform: "translate(-89.47 249.14) rotate(-45)",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,275.58a43,43,0,1,1,43-43A43.07,43.07,0,0,1,256,275.58Zm0-84a41,41,0,1,0,41,41A41.07,41.07,0,0,0,256,191.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.21,231.48v-1.83h13.52v1.83Zm0,1.08v1h13.52v-1Zm0-3.41h13.52V216.72h5.39L270,203.9l-12.15,12.82h5.39Zm0,5.76v.49h13.52v-.49Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.33,248.85a3.62,3.62,0,1,0,3.61,3.62A3.62,3.62,0,0,0,235.33,248.85Zm0,5.49a1.88,1.88,0,1,1,1.87-1.87A1.88,1.88,0,0,1,235.33,254.34Zm29.13-5.49a3.62,3.62,0,1,0,3.61,3.62A3.62,3.62,0,0,0,264.46,248.85Zm0,5.49a1.88,1.88,0,1,1,1.88-1.87A1.88,1.88,0,0,1,264.46,254.34Zm-30.68-6a.87.87,0,1,1,0-1.73H266a.87.87,0,1,1,0,1.73Zm40.44-27.12H232.76a.9.9,0,0,0-.68.32.85.85,0,0,0-.17.72L236.54,245a.87.87,0,0,0,.85.69h25a.87.87,0,0,0,.85-.69l4.49-22h6.48a.87.87,0,0,0,0-1.74Zm-9.44,7.58h-8.62l.3-5.84H266Zm-1.54,7.57h-7.47l.3-5.84h8.36Zm-17.49,0-.29-5.84h8.87l-.29,5.84Zm8.2,1.74-.3,5.84h-7.51l-.3-5.84Zm-18.59-7.58h8.36l.3,5.84h-7.47Zm10-1.73-.3-5.84h9.65l-.3,5.84Zm-2-5.84.3,5.84H235L233.82,223Zm-6.42,15.15h7.19l.3,5.84h-6.3ZM261.69,244h-6.3l.29-5.84h7.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.25,132.32,180.61,275V135.64a3.2,3.2,0,0,1,3.08-3.32h35.79a2.53,2.53,0,0,1,2.31,1.61l1.48,3.65a2.5,2.5,0,0,0,2.3,1.59h60.94a2.49,2.49,0,0,0,2.3-1.56l1.48-3.67a2.53,2.53,0,0,1,2.31-1.62Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.39 158.76 331.39 170.47 180.61 321.23 180.61 309.53 331.39 158.76",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shopping-bags--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.58,332a15.74,15.74,0,0,0-31.37,0,1.41,1.41,0,1,0,1,.05,14.74,14.74,0,0,1,29.37,0,1.42,1.42,0,1,0,1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.58,332a15.74,15.74,0,0,0-31.37,0,1.41,1.41,0,1,0,1,.05,14.74,14.74,0,0,1,29.37,0,1.42,1.42,0,1,0,1,0Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.36 417.04 94.6 417.04 99.5 354.54 99.48 354.54 99.48 330.91 160.49 330.91 160.49 354.54 160.46 354.54 165.36 417.04",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.04 417.04 103.82 406.06 94.6 417.04 99.5 354.54 99.48 354.54 99.48 330.91 109.02 330.91 109.02 354.54 109 354.54 113.04 417.04",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.04 417.04 103.82 406.06 103.82 330.91 109.02 330.91 109.02 354.54 109 354.54 113.04 417.04",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.58,332a15.74,15.74,0,0,0-31.37,0,1.41,1.41,0,1,0,1,.05,14.74,14.74,0,0,1,29.38,0,1.41,1.41,0,1,0,1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.58,332a15.74,15.74,0,0,0-31.37,0,1.41,1.41,0,1,0,1,.05,14.74,14.74,0,0,1,29.38,0,1.41,1.41,0,1,0,1,0Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,347.66a12.85,12.85,0,0,0-25.61,0,1.13,1.13,0,0,0-.79,1.07,1.15,1.15,0,1,0,2.29,0,1.12,1.12,0,0,0-.68-1,12,12,0,0,1,24,0,1.12,1.12,0,0,0-.68,1,1.15,1.15,0,1,0,2.29,0A1.13,1.13,0,0,0,176,347.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.36 417.04 137.62 417.04 141.61 366.03 141.6 366.03 141.6 346.75 191.39 346.75 191.39 366.03 191.36 366.03 195.36 417.04",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.36 417.04 137.62 417.04 141.61 366.03 141.6 366.03 141.6 346.75 191.39 346.75 191.39 366.03 191.36 366.03 195.36 417.04",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.66 417.04 145.14 408.08 137.62 417.04 141.61 366.03 141.6 366.03 141.6 346.75 149.38 346.75 149.38 366.03 149.37 366.03 152.66 417.04",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.66 417.04 145.14 408.08 145.14 346.75 149.38 346.75 149.38 366.03 149.37 366.03 152.66 417.04",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.49,347.66a12.85,12.85,0,0,0-25.61,0,1.12,1.12,0,0,0-.79,1.07,1.15,1.15,0,1,0,2.29,0,1.12,1.12,0,0,0-.68-1,12,12,0,0,1,24,0,1.12,1.12,0,0,0-.68,1,1.15,1.15,0,1,0,2.29,0A1.13,1.13,0,0,0,182.49,347.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.49,347.66a12.85,12.85,0,0,0-25.61,0,1.12,1.12,0,0,0-.79,1.07,1.15,1.15,0,1,0,2.29,0,1.12,1.12,0,0,0-.68-1,12,12,0,0,1,24,0,1.12,1.12,0,0,0-.68,1,1.15,1.15,0,1,0,2.29,0A1.13,1.13,0,0,0,182.49,347.66Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 395.62,
    cy: 137.87,
    r: 17.96,
    transform: "translate(18.38 320.13) rotate(-45)",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.28,134.06c0-1.51-1.29-2.53-3.37-2.53a5.09,5.09,0,0,0-4.4,2.07l-2.62-1.7c1.52-2.05,3.94-3.29,7.32-3.29,4,0,6.6,1.81,6.6,4.91,0,4.4-4.61,4.8-4.61,8h-3.42C393.78,137.51,398.28,136.76,398.28,134.06Zm-4.94,11.79A2.15,2.15,0,1,1,395.5,148,2.09,2.09,0,0,1,393.34,145.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.62 150.7 393.17 154.03 395.62 161.35 398.08 154.03 395.62 150.7",
    style: {
      fill: "#7E57C2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.75,216.52a111.8,111.8,0,0,1-13.48,6.91c-3.84,1.52-7.66,3.24-12,3.08-3-.08-6.28-2.65-6.11-6.1a8.52,8.52,0,0,1,2.47-5.15c7-7.35,15.29-13,23.69-18.62a2.72,2.72,0,0,1,3.4,4.21c-5,5.19-10.25,10.24-15.21,15.45-1.56,1.69-3.94,4.13-4.79,5.68a3.7,3.7,0,0,0,.24-2,4.25,4.25,0,0,0-1-2.25,4,4,0,0,0-2.11-1.2,46,46,0,0,0,7-2.87c4.13-2,8.4-4.35,12.5-6.6,6.32-3.24,11.42,5.68,5.42,9.49Z",
    style: {
      fill: "#b65b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.11,206a25.48,25.48,0,0,0-8.39,4.15l3.88-3.89-6-6.39s-22.22,14.32-19.75,23.24c2.05,7.37,16.58,2.57,24.81-1.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.11,206l-3.47,10.14-1.94,5.67c-.66.31-1.35.62-2.08.94-8.38,3.62-20.84,7.14-22.73.36-2.46-8.92,19.75-23.24,19.75-23.24l6,6.39-3.87,3.88A25.51,25.51,0,0,1,377.11,206Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.72,210.13s-6.12,6.53-7.47,8.83S367.76,215.09,368.72,210.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.64,216.12l-1.94,5.67c-.66.31-1.35.62-2.08.94A27.09,27.09,0,0,1,373.64,216.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.27,213.81c5.28,6.23,14.48,17.82,14.33,26.27-.79,9.24-13.32,20.44-20.18,26.15a2.72,2.72,0,0,1-3.87-3.77,175,175,0,0,0,11.85-16.92,17.68,17.68,0,0,0,2.34-5.56c0-.2,0-.1-.07-.3-.89-2.78-2.73-5.4-4.49-8-2.56-3.66-5.51-7.4-8.31-10.87-4.25-5.65,3.6-12.19,8.4-7Z",
    style: {
      fill: "#b65b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.73,278.94a289.45,289.45,0,0,0-45.49-2s7.88-52.19,10.38-59.07,39.06,6,39.06,6-5,20.71-6.15,33.73S411.65,276.93,409.73,278.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.73,278.94a289.45,289.45,0,0,0-45.49-2s7.88-52.19,10.38-59.07,39.06,6,39.06,6-5,20.71-6.15,33.73S411.65,276.93,409.73,278.94Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.09 410.21 358.92 412.14 360.54 401.51 361.42 395.83 354.59 393.89 353.43 401.51 352.09 410.21",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.36 410.77 398.4 411.7 398.46 401.51 398.51 395.18 391.46 394.26 391.41 401.51 391.36 410.77",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.46 394.26 391.41 401.51 398.46 401.51 398.51 395.18 391.46 394.26",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "353.43 401.51 360.54 401.51 361.42 395.83 354.59 393.89 353.43 401.51",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.17,409.14l7.76-.21a.63.63,0,0,1,.62.47l1.63,6.25a1,1,0,0,1-1,1.28c-2.8,0-6.85,0-10.36.07-4.11.11-6.73-.09-11.55,0-2.92.08-3.83-2.83-2.62-3.13,5.51-1.36,9.12-1.09,13.81-4.17A3.35,3.35,0,0,1,352.17,409.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.51,410.14h0c-1.14.26-3.16.6-4-.07a.93.93,0,0,1-.34-.81.55.55,0,0,1,.26-.45c.85-.51,3.75.86,4.08,1a.19.19,0,0,1,.1.17A.18.18,0,0,1,351.51,410.14Zm-3.84-1.07-.06,0a.22.22,0,0,0-.1.18.6.6,0,0,0,.23.53c.45.38,1.62.41,3.18.11C349.77,409.42,348.2,408.87,347.67,409.07Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.51,410.14h-.13c-.87-.36-2.62-1.85-2.52-2.65,0-.19.15-.42.61-.48a1.2,1.2,0,0,1,.94.26,4.79,4.79,0,0,1,1.2,2.69.17.17,0,0,1-.06.16Zm-2.16-2.76c-.14.05-.15.13-.15.16-.07.48,1.13,1.65,2,2.15a4,4,0,0,0-1-2.16.92.92,0,0,0-.69-.19A.53.53,0,0,0,349.35,407.38Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.64,409.14l7.75-.21a.63.63,0,0,1,.62.47l1.63,6.25a1,1,0,0,1-1,1.28c-2.8,0-6.85,0-10.37.07-4.11.11-6.72-.09-11.55,0-2.91.08-3.83-2.83-2.62-3.13,5.52-1.36,9.12-1.09,13.82-4.17A3.32,3.32,0,0,1,391.64,409.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,410.14h0c-1.14.26-3.16.6-4-.07a.94.94,0,0,1-.35-.81.55.55,0,0,1,.26-.45c.85-.51,3.75.86,4.08,1a.16.16,0,0,1,.1.17A.18.18,0,0,1,391,410.14Zm-3.83-1.07-.06,0a.18.18,0,0,0-.1.18.6.6,0,0,0,.22.53c.45.38,1.62.41,3.18.11C389.23,409.42,387.67,408.87,387.14,409.07Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,410.14h-.12c-.87-.36-2.63-1.85-2.52-2.65,0-.19.14-.42.6-.48a1.22,1.22,0,0,1,.95.26,4.79,4.79,0,0,1,1.2,2.69.17.17,0,0,1-.07.16Zm-2.16-2.76c-.14.05-.15.13-.15.16-.06.48,1.14,1.65,2,2.15a4,4,0,0,0-1-2.16.92.92,0,0,0-.69-.19A.61.61,0,0,0,388.81,407.38Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.88,256c3.73,16.18-2.67,143.39-2.67,143.39H390.84l-5.29-106-19.49,106-13.22-1c8.65-82.13,16.29-131.16,16.29-131.16l0-6.2Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.88,256c3.73,16.18-2.67,143.39-2.67,143.39H390.84l-5.29-106-19.49,106-13.22-1c8.65-82.13,16.29-131.16,16.29-131.16l0-6.2Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.4,315.88l4.14-22.55-.79-11.94S379.06,302.09,381.4,315.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.64 261.62 395.62 261.62 395.62 264.32 407.04 264.29 406.64 261.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.62 261.62 375.25 261.62 375.25 264.37 394.62 264.32 394.62 261.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.66 261.62 368.66 264.39 374.25 264.38 374.25 261.62 368.66 261.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.8,264.6h-2.87a.92.92,0,0,1-.92-.91v-1.4a.92.92,0,0,1,.92-.92h2.87a.92.92,0,0,1,.91.92v1.4A.91.91,0,0,1,385.8,264.6Zm-2.87-2.73a.42.42,0,0,0-.42.42v1.4a.41.41,0,0,0,.42.41h2.87a.41.41,0,0,0,.41-.41v-1.4a.41.41,0,0,0-.41-.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,263.24H382.9a.26.26,0,0,1-.25-.25.25.25,0,0,1,.25-.25H384a.25.25,0,0,1,.25.25A.25.25,0,0,1,384,263.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.63,210.62a125.64,125.64,0,0,0-5.86,20c-1,4.73-1.73,9.27-2.27,13.39-1.28,9.65-2.25,17.21-2.25,17.21L369.11,261c-2.49-35.43,8.46-53.51,8.46-53.51l9.43-2,1.92.06a155.37,155.37,0,0,1,15.62,2.05c1,.17,2,.37,2.93.58C412.36,209.25,416.63,210.62,416.63,210.62Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.63,210.62a125.64,125.64,0,0,0-5.86,20c-1,4.73-1.73,9.27-2.27,13.39-1.28,9.65-2.25,17.21-2.25,17.21L369.11,261c-2.49-35.43,8.46-53.51,8.46-53.51l9.43-2,1.92.06a155.37,155.37,0,0,1,15.62,2.05c1,.17,2,.37,2.93.58C412.36,209.25,416.63,210.62,416.63,210.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.22,208.31a16.64,16.64,0,0,1-12.39,3.31,3.59,3.59,0,0,1-3.36-4,7.62,7.62,0,0,0,3.28-1.36c2.37-1.83,2.2-4.93,1.58-7.91l10-7.82a49.74,49.74,0,0,0-1.16,7.43h0C400.82,202,401.17,206.18,403.22,208.31Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.13,197.93h0c-2,4.1-5.32,8.53-10.38,8.29,2.37-1.83,2.2-4.93,1.58-7.91l10-7.82A49.74,49.74,0,0,0,401.13,197.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.86,178.13c-1.55,2.34-2.63,7.73,1.45,7.05S389.52,174.13,386.86,178.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.34,186.94c-1.51,6.7-2,10.71-6,13.6a8.62,8.62,0,0,1-10.11.13,9.77,9.77,0,0,1-4.1-6.14,10,10,0,0,1-.17-1.22c-.47-6.34,2.08-16.24,9.14-17.8A9.48,9.48,0,0,1,404.34,186.94Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.75,182l2.13-7.37s8,1.68,6.5,5.59c3.72,3.41-.73,12.56-7.52,14.18-2.46-3.48.13-12.51.13-12.51C401.6,182,401.18,182,400.75,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,193a6.41,6.41,0,0,1-3.79,3.22c-2.18.68-3.36-1.26-2.82-3.37.48-1.89,2.2-4.52,4.43-4.28A3,3,0,0,1,406,193Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.75,187.07c-.08.55-.45,1-.81.89s-.58-.56-.49-1.12.45-.94.81-.88S393.84,186.52,393.75,187.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.52,186c-.09.55-.46.95-.82.89s-.58-.56-.49-1.12.45-.94.82-.88S387.61,185.45,387.52,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.46,186.61a19.16,19.16,0,0,1-3.42,4.1,3.34,3.34,0,0,0,2.55.89Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.21,194.22a4.93,4.93,0,0,1-.73-.08.16.16,0,0,1-.13-.19.15.15,0,0,1,.18-.13,4.36,4.36,0,0,0,3.84-1.1.17.17,0,0,1,.24,0,.17.17,0,0,1,0,.23A4.61,4.61,0,0,1,391.21,194.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,185.38a.32.32,0,0,1-.28-.17,2.63,2.63,0,0,0-1.9-1.44.33.33,0,0,1,.06-.66,3.33,3.33,0,0,1,2.42,1.79.33.33,0,0,1-.14.45A.29.29,0,0,1,396,185.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.18,183.39a.28.28,0,0,1-.18-.06.32.32,0,0,1-.08-.46,3.2,3.2,0,0,1,2.62-1.42.34.34,0,0,1,.32.34.32.32,0,0,1-.34.31,2.57,2.57,0,0,0-2.07,1.16A.3.3,0,0,1,385.18,183.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.46,180.79l5.47-1.19-2.25,1.63,7.15-.44-1.7.66a9.34,9.34,0,0,0,7.61-.22c3.82-2,3.64-1,3.64-1s1.4-4.73-8.63-8.56-18.78,3.12-13.3,7.73l1-.75S387.93,179.6,389.46,180.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.32,207.69a114.17,114.17,0,0,0-5.11,27.1v0c-.77,12.39-.69,47.54-.69,47.54s10.72-.29,11.61-1.53-1.92-13.38-.92-26.84c1-13.72,8.17-42.53,8.17-42.53a44.22,44.22,0,0,0-8.71-2.89C408.36,208.27,406.9,208,405.32,207.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.38,211.47s-1.38,5.56-3,13c-.48,2.16-1,4.48-1.47,6.86A202.48,202.48,0,0,0,410.21,254c-1,13.46,1.81,25.62.92,26.84s-11.61,1.53-11.61,1.53-.08-35.15.69-47.54v0a114.32,114.32,0,0,1,5.11-27.11c1.58.27,3,.58,4.35.9A43.91,43.91,0,0,1,418.38,211.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.32,207.69a114.17,114.17,0,0,0-5.11,27.1v0l11.06-17.28-4.79-1.9,5.77-1.47-2.58-5.6C408.36,208.27,406.9,208,405.32,207.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.48,278.68,366,281s-.72-21.07,7.57-46.91c.4-1.25.8-2.45,1.18-3.59,7.33-21.77,11.91-24.79,12.21-25l-3.52.16-6.37.32C367.23,225.38,363.48,278.68,363.48,278.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.48,278.68,366,281s-.72-21.07,7.57-46.91c.4-1.25.8-2.45,1.18-3.59,7.33-21.77,11.91-24.79,12.21-25l-3.52.16-6.37.32C367.23,225.38,363.48,278.68,363.48,278.68Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.32,212.22,377,213.45s-2.18,11.06-2.21,17c7.33-21.77,11.91-24.79,12.21-25l-3.52.16a22.52,22.52,0,0,0-6,4.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.37,224.43c-.48,2.16-1,4.48-1.47,6.86-1.65-3.52-.22-9.33-.22-9.33C414.15,221.92,415,224.35,415.37,224.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.77,260.91l1.94,3.81c.81,4.71-5.43,4.71-5.43,4.71l-3,1.21a2.41,2.41,0,0,1-2.9-1.17l-1.64-2.73a2.51,2.51,0,0,1,.6-3.46l2.41-1.47a5,5,0,0,1,2.32-.72Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.38,211.47c3.15,1.83,13.53,17.91,16.6,26.59s-16.6,24.43-16.6,24.43L412.33,257S421.7,245.5,423,240.85c0,0-5.68-10.4-8.46-13.57a22.24,22.24,0,0,1-.84-9.3A8.71,8.71,0,0,1,418.38,211.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.38,211.47c3.15,1.83,13.53,17.91,16.6,26.59s-16.6,24.43-16.6,24.43L412.33,257S421.7,245.5,423,240.85c0,0-5.68-10.4-8.46-13.57a22.24,22.24,0,0,1-.84-9.3A8.71,8.71,0,0,1,418.38,211.47Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.19,200.67a9.77,9.77,0,0,1-4.1-6.14,5.91,5.91,0,0,1,3.1,1.29C388,196.62,388.16,199,388.19,200.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.15,196.27l-.61,4.22c.74,4.73,6.65,2.73,6.65,2.73l3.24.18a2.41,2.41,0,0,0,2.36-2l.68-3.11a2.53,2.53,0,0,0-1.67-3.09l-2.76-.61a5,5,0,0,0-2.43.06Z",
    style: {
      fill: "#b55b52"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.32,88.27H130.8a11.18,11.18,0,0,0-11.18,11.18v13.49a11.19,11.19,0,0,0,11.18,11.19h5.48l1.3,8,6.22-8h19.52a11.18,11.18,0,0,0,11.18-11.19V99.45A11.17,11.17,0,0,0,163.32,88.27Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.39,105.43a2.26,2.26,0,1,1-2.26-2.26A2.26,2.26,0,0,1,134.39,105.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.34,105.43a2.26,2.26,0,1,1-2.26-2.26A2.26,2.26,0,0,1,144.34,105.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.3,105.43a2.26,2.26,0,1,1-2.26-2.26A2.26,2.26,0,0,1,154.3,105.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.25,105.43a2.26,2.26,0,1,1-2.26-2.26A2.26,2.26,0,0,1,164.25,105.43Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110.92,
    cy: 182.63,
    r: 48.67,
    transform: "translate(-87.11 262.87) rotate(-80.78)",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.3,235.33c-.51,0-1,0-1.54,0a.5.5,0,0,1-.48-.51.51.51,0,0,1,.51-.49c.5,0,1,0,1.51,0h.82a.5.5,0,0,1,.49.5.51.51,0,0,1-.5.5h-.81Zm-12.11-1.52h-.12a53.28,53.28,0,0,1-37.59-35.63.5.5,0,0,1,.32-.63.51.51,0,0,1,.63.33,52.3,52.3,0,0,0,36.89,35,.5.5,0,0,1-.13,1Zm28.72-.93a.5.5,0,0,1-.16-1A52.55,52.55,0,0,0,145,221.34a.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71,53.67,53.67,0,0,1-18.58,10.77A.44.44,0,0,1,126.91,232.88Zm22.23-14.41a.51.51,0,0,1-.34-.14.49.49,0,0,1,0-.7,50.52,50.52,0,0,0,13.84-34.23c0-.25,0-.5,0-.76a64.28,64.28,0,0,0-2.16-14.3.5.5,0,0,1,1-.26,64.91,64.91,0,0,1,2.2,14.53c0,.27,0,.53,0,.79a51.49,51.49,0,0,1-14.11,34.91A.52.52,0,0,1,149.14,218.47Zm-89.5-25.14a.5.5,0,0,1-.49-.4,49.4,49.4,0,0,1-.92-9.46c0-.28,0-.57,0-.85a67.45,67.45,0,0,1,1.37-11.15.52.52,0,0,1,.6-.39.5.5,0,0,1,.38.6,66.6,66.6,0,0,0-1.35,11c0,.27,0,.54,0,.82a48.14,48.14,0,0,0,.9,9.27.48.48,0,0,1-.39.58Zm97.47-34.6a.52.52,0,0,1-.45-.28c-.32-.64-.65-1.26-1-1.87a.5.5,0,0,1,.19-.68.49.49,0,0,1,.68.19c.35.63.69,1.26,1,1.91a.5.5,0,0,1-.23.67A.43.43,0,0,1,157.11,158.73Zm-91.49-1.68a.53.53,0,0,1-.24-.06.51.51,0,0,1-.2-.68c.35-.63.71-1.26,1.09-1.87a.49.49,0,0,1,.68-.17.5.5,0,0,1,.17.69c-.36.6-.72,1.21-1.06,1.83A.49.49,0,0,1,65.62,157.05Zm7.59-10.32a.52.52,0,0,1-.35-.14.5.5,0,0,1,0-.71c9.59-10,23.46-15.67,38.06-15.67a55.77,55.77,0,0,1,11.69,1.23.49.49,0,0,1,.38.59.5.5,0,0,1-.59.39,55.11,55.11,0,0,0-11.48-1.21c-14.33,0-27.94,5.6-37.34,15.37A.51.51,0,0,1,73.21,146.73Zm72.94-2.4a.55.55,0,0,1-.34-.13,49.71,49.71,0,0,0-18.29-10.42.5.5,0,1,1,.3-.95,50.73,50.73,0,0,1,18.66,10.62.5.5,0,0,1,0,.71A.51.51,0,0,1,146.15,144.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.59,182.63A48.67,48.67,0,1,1,110.92,134,48.64,48.64,0,0,1,159.59,182.63Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.55,185.48c8.62-1.15,17.87-1.59,26.14-4a5,5,0,0,0-1.14,1.59,4,4,0,0,0,0,3.23c-1.33-2-5.83-5.08-8.66-7.06-4.17-2.85-8.59-5.63-12.9-8.45a3.17,3.17,0,0,1,2.68-5.68,101.84,101.84,0,0,1,22.27,9.83c4.53,2.67,10.3,8,6.53,13.92-4.2,6.58-26,8.59-33.77,9.28-8.28.33-9.31-11.53-1.11-12.64Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.64,182.18c5.32.91,26.38,0,26.38,0L154.5,197s-14.85,4.4-22.2,4Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.76,167.92l-3.43-11.14-9.13,4.51s1.3,8.13,7.93,9.56Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.46 150.93 122.46 155.92 125.2 161.29 134.33 156.78 128.46 150.93",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.94,153.64c.78,3.64-.49,7.16-2.82,7.87s-4.86-1.66-5.64-5.29.49-7.16,2.82-7.87S125.17,150,125.94,153.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.94,153.64c.78,3.64-.49,7.16-2.82,7.87s-4.86-1.66-5.64-5.29.49-7.16,2.82-7.87S125.17,150,125.94,153.64Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2,166.34l-.11-.74a3.67,3.67,0,0,0,2.45-1,1.07,1.07,0,0,0,.18-.9c-.21-1.29-2.17-4.16-2.9-5.16l.6-.45c.11.16,2.76,3.76,3,5.48a1.88,1.88,0,0,1-.31,1.48A4.51,4.51,0,0,1,123.2,166.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,224.37A48.73,48.73,0,0,1,93.21,228c-.18-3.14-.42-6.16-.69-9.05-.43-4.65-1-9-1.52-12.82a196.53,196.53,0,0,0-4-20.59c22.14-10.69,43-.89,43-.89C135.6,192.76,136.42,210,136,224.37Z",
    style: {
      fill: "#7E57C2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,206.1c.55,3.86,1.09,8.17,1.52,12.83,1.86-3.7,4.06-12.53,1.16-21.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.56,189.6c-3.09-2.53-.42-6.36-.42-6.36-.68-2.34,2.73-6.9,10.73-6.61,9.31.33,15.21,3.16,15.21,5.85,0,0,3.84,2.78,4.46,4,2.14,4.16-4.46,10.56-4.46,10.56S107.38,198.43,96.56,189.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.76,195.17a24.31,24.31,0,0,1-1.68,1.87,36.57,36.57,0,0,1-5.5,0c-5.26-.4-13.37-2-20-7.39-3.09-2.53-.42-6.36-.42-6.36-.68-2.35,2.73-6.91,10.74-6.62,9.31.34,15.2,3.17,15.2,5.85,0,0,3.83,2.79,4.46,4C128,189.22,125.54,193,123.76,195.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.76,195.17a24.31,24.31,0,0,1-1.68,1.87,36.57,36.57,0,0,1-5.5,0,11.34,11.34,0,0,1,2.57-2.83c-12.92-1.67-19.05-10.53-19.51-12.27s5.79-3.76,5.85-3.69,7.58-.54,13.42,3.29c5.06,3.32,2.85,10.55,2.17,12.42A3.41,3.41,0,0,1,123.76,195.17Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.09,195.65s2.07,2.61,3,9.08a41.61,41.61,0,0,1,.36,10.7,8.35,8.35,0,0,1-3.38-.8,4.16,4.16,0,0,0-2.47-.55,57.25,57.25,0,0,0,.62-9.77C120,200,119.77,196.13,122.09,195.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.47,215.43a8.53,8.53,0,0,1-3.38-.8,4.25,4.25,0,0,0-2.47-.55s.27-1.82.48-4.18a43.17,43.17,0,0,0,.14-5.59c-.19-3.51-.38-6.77.84-8.09a1.73,1.73,0,0,1,1-.57s.07.09.2.3h0c.57.85,2,3.56,2.82,8.77A41.61,41.61,0,0,1,125.47,215.43Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.29,196a5.88,5.88,0,0,1-1,3.33,57.34,57.34,0,0,1,0,8.69,3.19,3.19,0,0,1-1.15,1.92,43.17,43.17,0,0,0,.14-5.59c-.19-3.51-.38-6.77.84-8.09a1.87,1.87,0,0,1,1.21-.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.55,195.35a3.36,3.36,0,0,0-3.56,2.14c-1.07,2.55-1.07,7.53-1.07,7.53s.77-1.06,1.72.54a2.67,2.67,0,0,0,2.91,1.07s-.39-8.14.42-9.14S120.55,195.35,120.55,195.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.55,195.35a3.36,3.36,0,0,0-3.56,2.14c-1.07,2.55-1.07,7.53-1.07,7.53s.77-1.06,1.72.54a2.67,2.67,0,0,0,2.91,1.07s-.39-8.14.42-9.14S120.55,195.35,120.55,195.35Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.23,194.67a2.64,2.64,0,0,0-3-.55,7.73,7.73,0,0,1,1.59,4h.12S122.91,196.24,122.23,194.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.23,194.67a2.64,2.64,0,0,0-3-.55,7.73,7.73,0,0,1,1.59,4h.12S122.91,196.24,122.23,194.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.9,194.36c-16.43-2.61-20.76-12-20.76-12,4-4.1,2-15.34.29-21.47l12.45,10c-.84,4.77-.64,9.84,6.33,11.48,0,0,2.86,1.11,2.87,7.55C122.08,193,120.92,194.37,120.9,194.36Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.5,165l7.37,5.91a18.52,18.52,0,0,0-.33,3.38c-2.65-.38-6.45-3.25-6.93-6A9.29,9.29,0,0,1,105.5,165Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.48,
    cy: 138.79,
    r: 10.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.79,131.51c12.37-.73,24.25,10.46,18.29,24.83S97.68,169.49,91,157C86.12,147.88,89.67,132.34,103.79,131.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.19,148.58c1.86,9.9,2.44,14.12,8.09,18.87,8.5,7.15,20.19,3.37,21.3-6.73,1-9.09-2.21-23.76-12.41-27S93.33,138.67,95.19,148.58Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.71,141.42c-5.47,7.05,5.76,15.16-5.47,14.69s-6.66-16.32,0-19.92S103.71,141.42,103.71,141.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.88,150.23c.12.83.65,1.48,1.19,1.44s.88-.75.75-1.59-.65-1.48-1.18-1.44S110.76,149.39,110.88,150.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,149.63c.12.84.65,1.48,1.19,1.44s.87-.75.75-1.58-.65-1.49-1.19-1.45S120.88,148.79,121,149.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.52,148.1l1.89-.72S122.62,149,121.52,148.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.38,151.21a24.49,24.49,0,0,0,3.7,5.13c-.94,1.12-2.85.78-2.85.78Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.23,158.13a6.93,6.93,0,0,0,4.21,3.69c2.31.61,3.31-2,2.54-4.67-.69-2.38-2.72-5.56-5-5S93.07,155.8,94.23,158.13Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.06,145.72a.45.45,0,0,0,.34-.15,3.65,3.65,0,0,1,3.21-1.23.45.45,0,0,0,.54-.38.55.55,0,0,0-.42-.59,4.54,4.54,0,0,0-4.07,1.51.5.5,0,0,0,0,.7A.54.54,0,0,0,108.06,145.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.27,144.82a.5.5,0,0,0,.34-.11.49.49,0,0,0,0-.7,5.2,5.2,0,0,0-4.19-1.86.44.44,0,0,0-.39.54.52.52,0,0,0,.56.43,4.16,4.16,0,0,1,3.31,1.52A.52.52,0,0,0,123.27,144.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.41,148.7l1.88-.73S112.51,149.62,111.41,148.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.45,136.45s-3,13.27-12.76,14.76S88.2,138.29,101.23,133s21.56,4.1,22.43,6.87a7.81,7.81,0,0,1-.25,5.87S118.66,136.7,108.45,136.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.45,159.62a27.59,27.59,0,0,0-1.32,3.93l-.73-.07c-3.3-.33-4.72-1.58-5.29-2.86a4.19,4.19,0,0,1-.32-2,4,4,0,0,1,.21-1.14c1.64,1.22,4.69,1.77,6.33,2C119,159.59,119.45,159.62,119.45,159.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.33,159.49l-.42,1.15c-3.1-.33-5.25-1-6.12-2a4,4,0,0,1,.21-1.14C113.64,158.71,116.69,159.26,118.33,159.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,163.48c-3.3-.33-4.72-1.58-5.29-2.86a10.9,10.9,0,0,1,3.59,1.1A4,4,0,0,1,117.4,163.48Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.48,155c.78,3.63-.48,7.16-2.82,7.87s-4.86-1.66-5.64-5.29.49-7.16,2.83-7.87S100.71,151.34,101.48,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.48,155c.78,3.63-.48,7.16-2.82,7.87s-4.86-1.66-5.64-5.29.49-7.16,2.83-7.87S100.71,151.34,101.48,155Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.82,153.15s-.53-17.91,8.69-21.58a4.51,4.51,0,0,0-2.52.18c-1.33.51-9.27,3.21-9.13,21.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.86,151.05c-.06,1.3,0,2.1,0,2.1l-3-.35c0-.38,0-.76,0-1.13.2-16.82,7.83-19.42,9.13-19.92a4.55,4.55,0,0,1,2.53-.18C98.25,134.46,97,146.21,96.86,151.05Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.74,
    y: 165.33,
    width: 2.82,
    height: 1.29,
    rx: 0.54,
    transform: "translate(-22.65 19.49) rotate(-8.29)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.74,
    y: 165.33,
    width: 2.82,
    height: 1.29,
    rx: 0.54,
    transform: "translate(-22.65 19.49) rotate(-8.29)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.82,153.15l-3-.35c0-.38,0-.76,0-1.13,0,0,.89-1.41,3-.62C96.8,152.35,96.82,153.15,96.82,153.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.15,155.89c.58,2.73-.37,5.38-2.13,5.92s-3.65-1.25-4.24-4,.37-5.38,2.13-5.92S98.56,153.16,99.15,155.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.15,155.89c.58,2.73-.37,5.38-2.13,5.92s-3.65-1.25-4.24-4,.37-5.38,2.13-5.92S98.56,153.16,99.15,155.89Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.42,212.7l11.37-2.55-3.8-9.46s-8.19.67-10.13,7.18Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.08 204.74 119.56 198.37 113.99 200.69 117.79 210.15 124.08 204.74",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.31,196.34c-3,8.17-6.87,16.57-8.55,25a5.19,5.19,0,0,0-.88-1.74A4,4,0,0,0,81,218.09c2.4-.26,7.2-2.81,10.28-4.41,4.46-2.37,9-5,13.46-7.51a3.17,3.17,0,0,1,3.79,5,102,102,0,0,1-19,15.18c-4.48,2.78-11.88,5.42-15.37-.66-1.83-3.65-.92-7.58-.28-11.09a129.19,129.19,0,0,1,7.7-23.13c3.55-7.49,14.53-2.92,11.72,4.87Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,185.51a15.72,15.72,0,0,1,9,12.59l-9.23,17.74-15.24,1.5S79,187.32,87,185.51Z",
    style: {
      fill: "#7E57C2"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.5825ca2e30f8398b27944ec0993a8196.svg";
export { ForwardRef as ReactComponent };